module.exports = __webpack_public_path__ + "img/panchito_waving-min.b42ae277.png";